export default "__VITE_ASSET__d2492702__"